import { fs45RecentRemovedQueueEntries } from "../firestore_schemas/fs45RecentRemovedQueueEntries"
import { getDocFrom_fs45RecentRemovedQueueEntries } from "../firestore_schemas/fs45RecentRemovedQueueEntries"
import { setDocIn_fs45RecentRemovedQueueEntries } from "../firestore_schemas/fs45RecentRemovedQueueEntries"
import { removeDocFrom_fs45RecentRemovedQueueEntries } from "../firestore_schemas/fs45RecentRemovedQueueEntries"

type Result = {
  debug_data: Array<string>;
  return_msg: string;
  success: boolean;
  error_title: string;
  error_summary: string;
  error_next_steps: string;
};

export async function fs45Writer(
  w_type: string,
  fs1_id: string,
  fs2_id: string,
  fs27_consumer_contact_uid: string,
  fs27_conversation_uid: string,
  data={consumer_uid: "", conversation_uid: ""}
) {

  const retval: Result = {
    debug_data: [],
    return_msg: "fs45_writer:fs45Writer ",
    success: true,
    error_title: "",
    error_summary: "",
    error_next_steps: "",
  };

  /// Validate arguments according to write type
  if (!fs1_id || !fs2_id) {
    retval.success = false;
    retval.return_msg += "Insufficient arguments.";
    retval.error_title = "Insufficient arguments.";
    retval.error_summary = "business_uid or recycler_uid not set.";
    retval.error_next_steps = "Please provide correct business_uid snd recycler_uid.";
    return retval;
  }


  if (!fs27_conversation_uid || !fs27_consumer_contact_uid) {
    retval.success = false;
    retval.return_msg += "Insufficient arguments.";
    retval.error_title = "Insufficient arguments.";
    retval.error_summary = "conversation_uid is not set.";
    retval.error_next_steps = "Please provide correct conversation_uid.";
    return retval;
  }
  /// <END> Validate arguments according to write type

  // Delete record
  if (w_type == "d") {
    await removeDocFrom_fs45RecentRemovedQueueEntries(fs1_id, fs2_id, fs27_consumer_contact_uid, fs27_conversation_uid)
    return retval
  }

  // Create new record
  if (w_type == "n") {
    await setDocIn_fs45RecentRemovedQueueEntries(
      fs1_id,
      fs2_id,
      fs27_consumer_contact_uid,
      fs27_conversation_uid,
      {consumer_contact_uid: data.consumer_uid, conversation_uid: data.conversation_uid}
    )
    return retval
  }

  // TODO - check if we need edit/update?
  // TODO - handle edit/upsert operations?
}

function firestoreWriteError(error:any) {
  // TODO - complete this
}
